export default __webpack_public_path__ + "static/media/directorpng.8aae2ab9.png";